export const isEqualWithoutCase = (a: string, b: string): boolean =>
  a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()) === 0;

export const isEqualWithCase = (a: string, b: string): boolean => a.localeCompare(b) === 0;
